import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';
import EpisodeCard from '@/components/feature/EpisodeCard';

export default function LatestEpisodes() {
  const latest = [...episodes].sort((a, b) => b.number - a.number).slice(0, 4);

  return (
    <section className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <span className="text-xs tracking-[0.3em] text-primary-400 font-heading uppercase">
              Latest Update
            </span>
            <h2 className="font-heading font-semibold text-foreground-950 text-2xl md:text-3xl mt-2">
              最新更新剧集
            </h2>
          </div>
          <Link
            to="/episodes"
            className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {latest.map((ep) => (
            <EpisodeCard key={ep.id} episode={ep} />
          ))}
        </div>
      </div>
    </section>
  );
}